import { each } from 'lodash';

import configure from './configure';

import {
  AuthDispatcherService as auth,
  AuthorizationService,
  CartService,
  SansConnectService,
  ConnectApiService,
  CognitoService as cognito,
  CoreService,
  ProductService as products,
  SansAuthService as sansAuth,
  SDKEventService as systemEvents,
  TokensService as tokens,
} from './services';

export * from './ApiRegistry';
export * from './AxiosAdapter';
export * from './configure';
export * from './RequestAdapter';
export * from './services';
export * from './SignedAxiosAdapter';
export * from './store';
export * from './utils';

const services = {
  systemEvents,
  sansAuth,
  auth,
  authorization: AuthorizationService.Api,
  cognito,
  tokens,
  products,
  cart: CartService.Api,
  connect: SansConnectService.Api,
  connectApi: ConnectApiService.Api,
  events: CartService.Api,
};

function createService() {
  const coreService = new CoreService();
  each(services, (ServiceClass, name) => {
    // @ts-ignore solve this typescript puzzle
    coreService.register(name, new ServiceClass());
  });
  return coreService;
}

const DefaultCore = createService();


export { configure, auth, cognito, tokens, createService, DefaultCore };
export default DefaultCore;
